import { Component } from '@angular/core';
import BaseIndexPageConfig from '../../../../components/pages/base-index-page/base-index-page.config';
import { DataTableColumnActions } from '../../../../components/widgets/data-table/columns/data-table-column-actions/data-table-column-actions.config';
import { DataTableColumnText } from '../../../../components/widgets/data-table/columns/data-table-column-text/data-table-column-text.config';
import ApiOptionsConfig from '../../../../services/api/api-options.config';
import { RegulationsService } from '../../../../services/api/general-settings/regulations.service';
import { RouteService } from '../../../../services/route.service';
import { BaseIndexPageComponent } from '../../../../components/pages/base-index-page/base-index-page.component';
import { filter } from 'rxjs';

@Component({
  selector: 'app-regulations-index-page',
  imports: [BaseIndexPageComponent],
  templateUrl: './regulations-index-page.component.html',
  styleUrl: './regulations-index-page.component.scss'
})
export class RegulationsIndexPageComponent {
 list: any[] = [];

  baseIndexPageConfig: BaseIndexPageConfig;

  constructor(
    protected regulationsService: RegulationsService,
    private routeService: RouteService
  ) {
    this.baseIndexPageConfig = {
      pageTitle: 'Regulations',
      cardTitle: 'Manage Regulations',
      addNewItemButton: {
        type: 'success',
        title: 'Add Regulation',
        onClick: () => {
          this.routeService.regulationsCreate()
        }
      },
      dataTable: {
        data: [],
        searchModel: {
          userId: null,
          firstName: null,
          lastName: null,
        },
        pagination: null,
        columns: [
          new DataTableColumnText({
            attribute: 'jurisdictionId',
            header: 'Jurisdiction',
            filter: 'select',
            filterOptionsSource: 'jurisdictions',
            value: (item: any) => {
              return item.jurisdiction.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'lawId',
            header: 'Law',
            filter: 'select',
            filterOptionsSource: 'laws',
            dependsOn: {
              column: 'jurisdictionId',
              fetchOptionsMethod: 'getLawsByJurisdiction'
            },
            value: (item: any) => {
              return item.law.name;
            }
          }),
          new DataTableColumnText({
            attribute: 'title',
            header: 'Title',
            filter: 'text',
            value: (item: any) => {
              return item.title;
            }
          }),
          new DataTableColumnText({
            attribute: 'details',
            header: 'Details',
            filter: 'text',
            value: (item: any) => {
              return item.details;
            }
          }),
          new DataTableColumnActions({
            header: 'Actions',
            attribute: 'actions',
            style: { width: '50px' },
            buttons: [
              {
                icon: 'fa-eye',
                tooltip: 'View regulation details',
                onClick: (item: any) => {
                  this.routeService.regulationsDetail(item.regulationId)
                }
              },
              {
                icon: 'fa-edit',
                tooltip: 'Edit regulation',
                onClick: (item: any) => {
                  this.routeService.regulationsUpdate(item.regulationId)
                }
              },
              {
                icon: 'fa-trash',
                tooltip: 'Delete regulation',
                onClick: (item: any) => {
                },
                isDelete: true
              },

            ]
          })
        ]
      },
      apiListService: (options: ApiOptionsConfig) => this.regulationsService.list(options),
      responseListModelName: 'regulations',
    }
  }
}
